// Toda mutação em Plantao (registrar, editar, mudar status, cancelar) afeta Dashboard,
// Recebíveis, Vínculo detalhe, KPIs, Calendário (via "plantoes") e Alertas — centralizado
// aqui para não duplicar a mesma lista de invalidateQueries em cada hook de mutação. A
// prévia da escala fixa ("shift-patterns") também: ela marca as datas já registradas.
const AFFECTED_QUERIES = ["plantoes", "vinculos", "dashboard", "kpis", "alertas", "shift-patterns"];

export function invalidateShiftQueries(queryClient) {
  AFFECTED_QUERIES.forEach((queryKey) => queryClient.invalidateQueries({ queryKey: [queryKey] }));
}
